export const BASE_URL = 'https://io2.vitechliu.com/api';
export const NON_IMAGE_URL = 'https://vitech.oss-cn-qingdao.aliyuncs.com/sprite/%E6%9A%82%E6%97%A0%E5%9B%BE%E7%89%87.png';
